import React, { useCallback, useRef } from "react";
import { Send, Paperclip } from "lucide-react";
import style from "./ChatInput.module.scss";

const ChatInput = ({ 
  value, 
  onChange, 
  onSend, 
  placeholder, 
  disabled = false, 
  disabledMessage,
  onFileSelect,
  isUploading = false
}) => {
  const fileInputRef = useRef(null);

  const handleKeyDown = useCallback(
    (e) => {
      if (disabled || isUploading) return;
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSend();
      }
    },
    [onSend, disabled, isUploading],
  );

  const handleSend = useCallback(() => {
    if (disabled || isUploading || !value.trim()) return;
    onSend();
  }, [onSend, disabled, isUploading, value]);

  const handleAttachClick = useCallback(() => {
    if (disabled || isUploading) return;
    fileInputRef.current?.click();
  }, [disabled, isUploading]);

  const handleFileChange = useCallback(
    (e) => {
      const file = e.target.files?.[0];
      if (file && onFileSelect) {
        onFileSelect([file]);
      }
      e.target.value = "";
    },
    [onFileSelect],
  );

  const canSend = !disabled && !isUploading && value.trim();

  return (
    <div className={style.message_input_area}>
      <div className={style.message_input_wrapper}>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className={style.file_input}
        />

        <button
          type="button"
          className={style.attach_button}
          onClick={handleAttachClick}
          disabled={disabled || isUploading}
          title={disabled ? disabledMessage : placeholder}
        >
          <Paperclip size={20} />
        </button>

        <textarea
          className={style.message_input}
          placeholder={disabled ? disabledMessage || placeholder : placeholder}
          value={value}
          onChange={(e) => !disabled && !isUploading && onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          rows={1}
          disabled={disabled || isUploading}
          title={disabled ? disabledMessage : ""}
        />

        <button 
          className={style.send_button} 
          onClick={handleSend} 
          disabled={!canSend}
          title={disabled ? disabledMessage : ""}
        >
          {isUploading ? (
            <span className={style.uploading_indicator}>...</span>
          ) : (
            <Send size={20} color={canSend ? "#155DFC" : "#99A1AF"} />
          )}
        </button>
      </div>
    </div>
  );
};

export default ChatInput;
